<template>
  <div class="ui form">
    <h4 class="ui dividing header">{{ $t("issuer") }}</h4>
    <div class="three fields">
      <div class="field">
        <label for>{{ $t("email") }}</label>
        <input type="text" name="issuer_email" v-model="issuer_email" />
      </div>
      <div class="field">
        <label for>{{ $t("establishment code") }}</label>
        <input type="text" name="issuer_establishment_code" v-model="issuer_establishment_code" />
      </div>
      <div class="field">
        <label for>{{ $t("nit") }}</label>
        <input type="text" name="issuer_nit" v-model="issuer_nit" />
      </div>
    </div>
    <div class="three fields">
      <div class="field">
        <label for>{{ $t("comercial name") }}</label>
        <input type="text" name="issuer_comercial_name" v-model="issuer_comercial_name" />
      </div>
      <div class="field">
        <label for>{{ $t("iva affiliation") }}</label>
        <input type="text" name="issuer_iva_affiliation" v-model="issuer_iva_affiliation" />
      </div>
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="issuer_name" v-model="issuer_name" />
      </div>
    </div>
    <h4 class="ui dividing header">{{ $t("g4s membership") }}</h4>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("requestor") }}</label>
        <input type="text" name="g4s_requestor" v-model="g4s_requestor" />
      </div>
      <div class="field">
        <label for>{{ $t("user") }}</label>
        <input type="text" name="g4s_user" v-model="g4s_user" />
      </div>
    </div>
  </div>
</template>

<script>
import currency from "@/currency";

export default {
  name: "MegaprintBilling",
  props: {
    setup_in: Object
  },
  data() {
    return {
      issuer_email: "",
      issuer_establishment_code: "",
      issuer_nit: "",
      issuer_comercial_name: "",
      issuer_iva_affiliation: "",
      issuer_name: "",
      g4s_requestor: "",
      g4s_user: ""
    };
  },
  mounted() {
    let vm = this;
    let curr = Object.keys(currency).map(k => {
      return {
        value: currency[k].code,
        name: `${currency[k].name} (${currency[k].code})`
      };
    });

    if (vm.setup_in) {
      vm.issuer_email = vm.setup_in.issuer_email;
      vm.issuer_establishment_code = vm.setup_in.issuer_establishment_code;
      vm.issuer_nit = vm.setup_in.issuer_nit;
      vm.issuer_comercial_name = vm.setup_in.issuer_comercial_name;
      vm.issuer_iva_affiliation = vm.setup_in.issuer_iva_affiliation;
      vm.issuer_name = vm.setup_in.issuer_name;
      vm.g4s_requestor = vm.setup_in.g4s_requestor;
      vm.g4s_user = vm.setup_in.g4s_user;
    }

    window
      .jQuery(vm.$refs.currency_dropdown)
      .dropdown("setup menu", { values: curr })
      .dropdown({
        onChange(value) {
          vm.currency = value;
        }
      });
  },
  methods: {
    emit() {
      this.$emit("update", {
        issuer_email: this.issuer_email,
        issuer_establishment_code: this.issuer_establishment_code,
        issuer_nit: this.issuer_nit,
        issuer_comercial_name: this.issuer_comercial_name,
        issuer_iva_affiliation: this.issuer_iva_affiliation,
        issuer_name: this.issuer_name,
        g4s_requestor: this.g4s_requestor,
        g4s_user: this.g4s_user
      });
    }
  },
  watch: {
    issuer_email() {
      this.emit();
    },
    issuer_establishment_code() {
      this.emit();
    },
    issuer_nit() {
      this.emit();
    },
    issuer_comercial_name() {
      this.emit();
    },
    issuer_iva_affiliation() {
      this.emit();
    },
    issuer_name() {
      this.emit();
    },
    g4s_requestor() {
      this.emit();
    },
    g4s_user() {
      this.emit();
    }
  }
};
</script>
